module.exports = "/images/pillMobileBG.png?e4929a822777d823822e7061b3b34342";